<template></template>
<script>
export default {
  data() {
    return {
      params: ""
    };
  },
  methods: {
    async login(mail, pass) {
      try {
        await this.$store.dispatch("user/signin", {
          email: mail,
          password: pass
        });
        this.$router.replace({ name: "welcomePage" });
      } catch (e) {
        console.log(e);
      }
    },
    async logout() {
      try {
        await this.$store.dispatch("user/signout", false);
      } catch(e) {
        console.log(e);
      }
    }
  },
  beforeMount() {
    this.params = this.$route.query; 
    this.login(this.params.email, this.params.hash);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/template/Udawaj.vue